import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import "./i18n/config";

// Production-ready initialization with comprehensive error handling
console.log('[MeetHub] Starting MeetHub v1.0');

const rootElement = document.getElementById("root");

if (!rootElement) {
  console.error('[MeetHub] FATAL: Root element not found');
  document.body.innerHTML = `
    <div style="display: flex; align-items: center; justify-content: center; min-height: 100vh; padding: 20px; font-family: system-ui, sans-serif;">
      <div style="text-align: center; max-width: 500px;">
        <h1 style="color: #dc2626; margin-bottom: 16px;">Critical Error</h1>
        <p style="color: #666; margin-bottom: 24px;">Root element missing. Contact support.</p>
      </div>
    </div>
  `;
} else {
  try {
    console.log('[MeetHub] Initializing React application...');
    
    // Create React root and render
    const root = createRoot(rootElement);
    root.render(<App />);
    
    console.log('[MeetHub] ✅ Application started successfully');
    
    // Initialize monitoring (non-blocking)
    setTimeout(() => {
      import("./lib/monitoring/sentry")
        .then(({ initSentry }) => {
          initSentry();
          console.log('[MeetHub] Monitoring initialized');
        })
        .catch((err) => console.warn('[MeetHub] Monitoring init failed:', err));
      
      import("./lib/monitoring/performance")
        .then(({ initPerformanceMonitoring, trackPageLoad }) => {
          initPerformanceMonitoring();
          trackPageLoad();
        })
        .catch((err) => console.warn('[MeetHub] Performance tracking failed:', err));
    }, 1000);
    
  } catch (error) {
    console.error('[MeetHub] ❌ Application startup failed:', error);
    
    const errorMessage = error instanceof Error ? error.message : String(error);
    const errorStack = error instanceof Error ? error.stack : '';
    
    rootElement.innerHTML = `
      <div style="display: flex; align-items: center; justify-content: center; min-height: 100vh; padding: 20px; font-family: system-ui, sans-serif; background: #fff;">
        <div style="max-width: 600px; text-align: center;">
          <h1 style="color: #dc2626; margin-bottom: 16px; font-size: 24px;">⚠️ Startup Failed</h1>
          <p style="color: #666; margin-bottom: 24px; font-size: 16px;">MeetHub encountered an error during startup.</p>
          <button onclick="window.location.reload()" style="background: #7c3aed; color: white; padding: 14px 28px; border: none; border-radius: 8px; cursor: pointer; font-size: 16px; font-weight: 600; margin-bottom: 16px;">
            🔄 Refresh Page
          </button>
          <details style="margin-top: 24px; text-align: left; padding: 16px; background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 8px;">
            <summary style="cursor: pointer; font-weight: 600; margin-bottom: 12px; color: #374151;">Error Details</summary>
            <pre style="font-size: 11px; line-height: 1.5; overflow: auto; white-space: pre-wrap; word-wrap: break-word; color: #1f2937; font-family: monospace; background: #fff; padding: 12px; border-radius: 4px; border: 1px solid #e5e7eb;">${errorMessage}\n\n${errorStack}</pre>
          </details>
          <p style="margin-top: 20px; font-size: 13px; color: #9ca3af;">
            Try clearing your browser cache (Ctrl+Shift+Delete)
          </p>
        </div>
      </div>
    `;
  }
}
